export default function TabRouteWrapper() {
  return null;
}